import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Dropzone from "dropzone";
import { Modal, Button } from "react-bootstrap";
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import Webcam from "react-webcam";
import _ from "lodash";
import { getCovidTestResult } from "../api";
import Waiting from "../components/Waiting";
import QuestionnaireV2 from "../components/QuestionnaireV2";
import useToastify from "../hooks/useToastify";
import {
  initFaceMesh,
  detectFacesFromVideo,
  playAudio,
  resizeAndCropImages,
  getMaxResolutionOfCamera,
} from "../utils/covid/TestPageUtil";
import { getImageDimention, sleep, asyncGetState } from "../utils/common";
import { detectFaces } from "../utils/covid/faceLandmarker";
import imageValidation from "../utils/covid/automatedImageValidationV2";
import covidMessageList from "../enum/covidMessageList";
import CenterMan from "../assets/SVG/signs/Face-man-center.svg";
import LeftMan from "../assets/SVG/signs/Face-man-right.svg";
import RightMan from "../assets/SVG/signs/Face-man-left.svg";
import UpMan from "../assets/SVG/signs/Face-man-Up.svg";
import LandscapeCenter from "../assets/SVG/landscape-faces/faces-center.svg";
import LandscapeLeft from "../assets/SVG/landscape-faces/faces-right.svg";
import LandscapeRight from "../assets/SVG/landscape-faces/faces-left.svg";
import LandscapeUp from "../assets/SVG/landscape-faces/faces-up.svg";
import CloseIcon from "../assets/SVG/buttons/close-icon.svg";
import CountAudio_1 from "../assets/audio/1.mp3";
import CountAudio_2 from "../assets/audio/2.mp3";
import CountAudio_3 from "../assets/audio/3.mp3";
import Shutter from "../assets/audio/shutter.mp3";
import AudioCenter from "../assets/audio/center.mp3";
import AudioRight from "../assets/audio/right.mp3";
import AudioLeft from "../assets/audio/left.mp3";
import AudioUp from "../assets/audio/up.mp3";
import AudioComeCloser from "../assets/audio/close-to-camera.mp3";
import BadQuality from "../assets/audio/bad-quality.mp3";
import { trackCovidTestPage } from "../utils/mixpanel";
import "../styles/testpage.css";

Dropzone.autoDiscover = false;

// Global Variables
window.stopFaceMesh = false;
window.isTakingPicture = false;
let detectResultFromVideo;
let lightScoreGlobal, prevLightScoreGlobal;

export default function TestPage(props) {
  const isSTablet = navigator.maxTouchPoints > 0 && navigator.platform == "Linux armv81";
  const MAX_RESOLUTION_WIDTH = 2500;
  const MAX_TABLET_RESOLUTION_WIDTH = 3000;
  const adjustedNum = isMobileOnly ? 0.95 : 0.65;
  const DISTANCE_THRESHOLD = window.screen.width > window.screen.height ? 0.85 : isTablet ? 1.6 : 2.0;
  const maxCameraWidth = 4320;
  const maxCameraHeight = 7680;
  const landscape = window.matchMedia("(orientation: landscape)");
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const isFrontCamera = !(isMobile || isSTablet) ? true : location?.state?.iselfie;
  const history = useHistory();
  const _isCamLoading = !props?.isCamLoading ? true : false;
  const [isCamLoading, setIsCamLoading] = useState(_isCamLoading); // Loading and waiting for FaceMesh initiate.
  const [isImageValidating, setIsImageValidating] = useState(false); // Loading and waiting for Image Validation.

  const { notifySuccess, notifyError } = useToastify();

    // Loading message while loading camera and faceMesh()
  const LOADING_MSG = "Starting the camera....";
  const LOADING_ENVIRONMENT = "Preparing the environment. please wait....";

  //TODO Rename the isSlow to isNetworkSlow
  const [isSlow, setIsSlow] = useState(); // When network is slow.

  // Counter when counting begins before taking picture.
  const [counter, setCounter] = useState(); // When network is slow.

  //isFailed // TODO Rename the isFailed to isCameraAccessFail
  const [isFailed, setIsFailed] = useState(); // When Camera Access failed

  //errorMsg // TODO Rename the errorMsg to cameraErrorMsg
  const [errorMsg, setErrorMsg] = useState(); // Camera Access failed Message

  const [thumbnailUrls, setThumbnailUrls] = useState([]); // Array of pictures taken
  const [thumbnailUrlCoordinates, setthumbnailUrlCoordinates] = useState([]); // Array of coordinates of pictures taken
  const [eyeImages, setEyeImages] = useState([]); // Array of coordinates of pictures taken
  const [smallImages, setSmallImages] = useState([]); // Array of small image of pictures taken
  const [smallImageUrls, setSmallImageUrls] = useState([]); // Array of small image url of pictures taken
  const [landscapeMode, setLandscapeMode] = useState(landscape?.matches); // If Device is in Landscape Mode.

  // TODO Rename isQsnOpen to openSymptomsModal
  const [isQsnOpen, setIsQsnOpen] = useState(false); // Open Questionnaire model.
  const [isResizeAndCropReady, setIsResizeAndCropReady] = useState(false); // Open Questionnaire model.
  const [hideCameraContainer, setHideCameraContainer] = useState(false); // Open Questionnaire model.

  const [isCameraResolutionValid, setIsCameraResolutionValid] = useState(false); // Check if Camera Resolution is above requirement.

  //isWaitingCovidResult TODO Rename isWaitingCovidResult to isWaitingCovidResult
  const [isWaitingCovidResult, setIsWaitingCovidResult] = useState(false); // Waiting for Covid result

  //faceMesh TODO Rename faceMesh to isFaceMeshLoaded.
  const [faceMesh, setFaceMesh] = useState(null); // If true FaceMesh didn't load/initiate

  // const [loaded, setLoaded] = useState(false);

  // CUSTOM NEW

  const [cameraMaxResolution, setCameraMaxResolution] = useState();
  const [faceLandmarker, setFaceLandmarker] = useState();
  const [cameraAspectRatio, setCameraAspectRatio] = useState(3 / 4);
  const [frameWidth, setFrameWidth] = useState(isMobile || isSTablet ? window.innerWidth * adjustedNum : 640);
  const [frameHeight, setFrameHeight] = useState(isMobile || isSTablet ? window.innerWidth * cameraAspectRatio * adjustedNum : 360);
  const [devices, setDevices] = React.useState([]);

  const [cameraMode, setCameraMode] = useState(isFrontCamera ? "user" : "environment"); // user || environment
  const [hasCameraAccess, setHasCameraAccess] = useState(false);
  const [cameraResolution, setCameraResolution] = useState({ width: maxCameraWidth, height: maxCameraHeight });  

  const webcamRef = useRef();
  const canvasRef = useRef();

  const goToManual = () => {
    window.isTakingPicture = false;
    window.stopFaceMesh = true;
    window.audioInstance = null;
    history.push({
      pathname: '/testWithUpload',
      state: { isDemo: location?.state?.isDemo }
    });
  };
  const handleClose = async () => {
    window.isTakingPicture = false;
    window.stopFaceMesh = true;
    window.audioInstance = null;
    history.push("/home");
  };
  const handleRetry = () => {
    window.location.reload();
  };

  const onGetUserMediaHandle = async (stream) => {
    const stream_settings = stream.getVideoTracks()[0].getSettings();
    stream.getVideoTracks()[0].stop();

    let { width: cameraWidth, height: cameraHeight } = stream_settings;
    let _aspectRatio = 3 / 4;
    let _cameraWidth = stream_settings.width;
    let _cameraHeight = stream_settings.height;

    if (landscapeMode) {
      // Landscape mode
      if(cameraWidth > cameraHeight) {
        _cameraWidth = cameraWidth;
        _cameraHeight = cameraHeight;
      } else {
        _cameraWidth = cameraHeight;
        _cameraHeight = cameraWidth;
      }
    } else {
        // Portrait mode
        if(cameraWidth > cameraHeight) {
          _cameraWidth = cameraHeight;
          _cameraHeight = cameraWidth;
        } else {
          _cameraWidth = cameraWidth;
          _cameraHeight = cameraHeight;
        }
    }
    
    if(isMobile || isSTablet) {
      _aspectRatio = _cameraWidth > _cameraHeight ? _cameraWidth / _cameraHeight : _cameraHeight / _cameraWidth;
      if(isTablet || isSTablet) {
        _aspectRatio = !landscapeMode && _cameraWidth > _cameraHeight ? _cameraWidth / _cameraHeight : _cameraHeight / _cameraWidth;  
      }
    }

    let adjustedCameraWidth = _cameraWidth < MAX_RESOLUTION_WIDTH ? _cameraWidth : MAX_RESOLUTION_WIDTH;
    let adjustedCameraHeight =
      _cameraWidth < MAX_RESOLUTION_WIDTH ? _cameraHeight : landscapeMode ? _cameraHeight * _aspectRatio : MAX_RESOLUTION_WIDTH * _aspectRatio;
    
    const resolution = _cameraWidth * _cameraHeight; 
    if(isTablet && resolution < 6500000) {
      adjustedCameraWidth = MAX_TABLET_RESOLUTION_WIDTH;
      adjustedCameraHeight = MAX_TABLET_RESOLUTION_WIDTH * _aspectRatio;
    }        

    setCameraResolution({ width: adjustedCameraWidth, height: adjustedCameraHeight });

    const minimumWidth = _cameraWidth > _cameraHeight ? 2560 : 1440;
    const minimumHeight = _cameraWidth > _cameraHeight ? 1440 : 2560;
    if (_cameraWidth < minimumWidth || _cameraHeight < minimumHeight) {
      setIsCameraResolutionValid(true);
      return;
    }

    if (isMobile || isSTablet) {
      setCameraAspectRatio(_aspectRatio);
      setFrameHeight(window.innerWidth * _aspectRatio * adjustedNum);
    } else {
      // Making aspect ratio for desktop top landscape
      const _aspectRatio = 3 / 4;
      // setFrameHeight(window.innerWidth * _aspectRatio * adjustedNum);
      setFrameHeight(480);
    }

    setHasCameraAccess(true);
  };

  const onGetuserMediaErrorHandle = (error) => {
    switch (error.name) {
      case "NotReadableError":
        setErrorMsg(
          "It looks like another app is using the camera already. Please turn off the camera in another app and click on the Retry button."
        );
        setIsFailed(true);
      case "NotFoundError":
        setErrorMsg("We cannot find your camera. Please connect your camera and click on the Retry button");
        setIsFailed(true);
      case "NotAllowedError":
        setErrorMsg(
          "Please change the permission settings on your browser to allow access to camera and click on the Retry button."
        );
        setIsFailed(true);
      default:
        console.log("onGetuserMediaErrorHandle::", error)
        setErrorMsg("We cannot access your camera. Please check your camera and click on the Retry button.");
        setIsFailed(true);
    }
  };

  useEffect(() => {
    // Redirect to Previous route if refresh or direct access to this page.
    if (!user?.isNotRefresh) {
      history.push("intermediary");
      return;
    }
    if (!(isMobile || isSTablet)) {
      // Show DeviceId Selector or selectDeviceId which has highest resolution
      getMaxResolutionOfCamera({
        setCameraResolution,
        setIsCameraResolutionValid,
        setCameraAspectRatio,
        setFrameHeight,
        setHasCameraAccess,
        isMobile,
        setErrorMsg,
        setIsFailed
      }).then((result) => {
        setCameraMaxResolution(result);
      });
      return;
    } else {
      if (cameraMode === "user") {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              width: maxCameraWidth,
              height: maxCameraHeight,
              aspectRatio: isMobile || isSTablet ? 3 / 4 : 4 / 3,
              facingMode: cameraMode,
            },
          })
          .then(onGetUserMediaHandle)
          .catch(onGetuserMediaErrorHandle);
      } else {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              width: maxCameraWidth,
              height: maxCameraHeight,
              aspectRatio: isMobile || isSTablet ? 3 / 4 : 4 / 3,
              facingMode: cameraMode,
            },
          })
          .then(onGetUserMediaHandle);
      }
    }
  }, []);

  useEffect(() => {
    landscape.addEventListener("change", (event) => {
      window.location.reload();
      if (event.matches) {
        setLandscapeMode(true)
      } else {
        setLandscapeMode(false)
      }
    });
  }, [])

  // Track mixpanel
  useEffect(() => {
    if (props?.user?.uid) {
      trackCovidTestPage(this.props.user.uid);
    }
  }, []);

  // Refresh the page when back button is pressed.
  useEffect(() => {
    window.onpopstate = (e) => {
      window.location.reload();
    };
  });

  // Initiate Vision Task
  useEffect(() => {
    initFaceMesh().then(async (_faceLandmarker) => {
      // Initiating Facemesh to buffer the initialization.

      const iniDummyCanvas = document.createElement("canvas");
      const _MAX_RESOLUTION_WIDTH = MAX_RESOLUTION_WIDTH / 2 // Making smaller max resolution for dummy init for detecting face.
      iniDummyCanvas.width = _MAX_RESOLUTION_WIDTH;
      iniDummyCanvas.height = (_MAX_RESOLUTION_WIDTH * 4) / 3;

      const ctx = iniDummyCanvas.getContext("2d");
      ctx.fillRect(0, 0, _MAX_RESOLUTION_WIDTH, (_MAX_RESOLUTION_WIDTH * 4) / 3);
      ctx.imageSmoothingEnabled = false;
      // ctx.drawImage(img, out_minx, out_miny, width, height, 0, 0, width, height);
      const predictions = await detectFaces(iniDummyCanvas);
      console.log("init predictions", predictions)
      setFaceLandmarker(_faceLandmarker);
    });
  }, []);

  const detectResultHandle = async (
    faceLandmarker,
    videoNode,
    canvasNode,
    frameWidth,
    frameHeight,
    lightingScore,
    previousLightingScore,
    finalImageWidth,
    finalImageHeight,
    isLandscapeMode
  ) => {
    if (faceLandmarker) {
      const detectResult = await detectFacesFromVideo(
        faceLandmarker,
        videoNode,
        canvasNode,
        frameWidth,
        frameHeight,
        lightingScore,
        previousLightingScore,
        finalImageWidth,
        finalImageHeight,
        isLandscapeMode
      );
      detectResultFromVideo = detectResult;

      let _lightingScore = lightingScore;
      let _previousLightingScore = previousLightingScore;
      if (detectResult?.drawResult) {
        _lightingScore = detectResult.drawResult.lightingScore;
        _previousLightingScore = detectResult.drawResult.lightingScore;
        lightScoreGlobal = _lightingScore;
        prevLightScoreGlobal = _previousLightingScore;
        if (!window?.isTakingPicture) {
          takePictureInit();
        }
      }

      if (window?.stopFaceMesh) return;
      requestAnimationFrame(() =>
        detectResultHandle(
          faceLandmarker,
          videoNode,
          canvasNode,
          frameWidth,
          frameHeight,
          _lightingScore,
          _previousLightingScore,
          finalImageWidth,
          finalImageHeight,
          isLandscapeMode
        )
      );
    }
  };

  const handleVideoLoad = async (videoNode) => {
    window.stopFaceMesh = false;

    const video = videoNode.target;
    if (video.readyState !== 4) return;
    setIsCamLoading(false);
    const _faceLandmarker = props?.faceLandmarker || faceLandmarker;
    if (_faceLandmarker) {
      await detectResultHandle(
        _faceLandmarker,
        video,
        canvasRef.current,
        frameWidth,
        frameHeight,
        lightScoreGlobal,
        prevLightScoreGlobal,
        cameraResolution.width,
        cameraResolution.height,
        landscapeMode
      );
    }
  };

  const takePictureInit = async () => {
    const imagesStepsAndValidation = {
      center: {
        gaze: false, // Gaze direction
        eyeSize: false, // Eye Size
        blink: false, // Check if Eye is blinked
        light: false, // Lighting
      },
      right: {
        gaze: false, // Gaze direction
        eyeSize: false, // Eye Size
        blink: false, // Check if Eye is blinked
        light: false, // Lighting
      },
      left: {
        gaze: false, // Gaze direction
        eyeSize: false, // Eye Size
        blink: false, // Check if Eye is blinked
        light: false, // Lighting
      },
      up: {
        gaze: false, // Gaze direction
        eyeSize: false, // Eye Size
        blink: false, // Check if Eye is blinked
        light: false, // Lighting
      },
    };
    // Take pictures and validate.
    window.isTakingPicture = true;
    window.isReanalyzing = false;
    for await (const [stepIndex, eyeStep] of Object.keys(imagesStepsAndValidation).entries()) {
      const recursiveTakePictureAndValidate = async () => {
        if (!window.isTakingPicture) return;

        if(!window.isReanalyzing) {
          switch (eyeStep) {
            case "center":
              await playAudio(AudioCenter);
              break;
            case "right":
              await playAudio(AudioRight);
              break;
            case "left":
              await playAudio(AudioLeft);
              break;
            case "up":
              await playAudio(AudioUp);
              break;
          }
  
          await sleep(1250);
          setCounter(3);
          await playAudio(CountAudio_3);
          await sleep(250);
          setCounter(2);
          await playAudio(CountAudio_2);
          await sleep(250);
          setCounter(1);
          await playAudio(CountAudio_1);
          await sleep(1250);
          setCounter();
        }
        console.log("detectResultFromVideo", detectResultFromVideo)
        console.log("DISTANCE_THRESHOLD", DISTANCE_THRESHOLD)
        // Check if the eye_size is okay AFTER countdown.
        if (!detectResultFromVideo?.eye_size) {
          await playAudio(AudioComeCloser);
          await sleep(2000);
          window.isReanalyzing = true;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }
        // Checking if Too farm from camera AFTER countdown
        if (detectResultFromVideo?.rr < DISTANCE_THRESHOLD && detectResultFromVideo?.rl < DISTANCE_THRESHOLD) {
          await playAudio(AudioComeCloser);
          await sleep(2000);
          window.isReanalyzing = true;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }
        // Check if the head and gaze are in the correct position AFTER countdown
        if (eyeStep === "center" && !detectResultFromVideo?.position?.[0]) {
          await playAudio(AudioCenter);
          await sleep(2000);
          window.isReanalyzing = true;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }
        if (eyeStep === "right" && !detectResultFromVideo?.position?.[1]) {
          await playAudio(AudioRight);
          await sleep(2000);
          window.isReanalyzing = true;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }
        if (eyeStep === "left" && !detectResultFromVideo?.position?.[2]) {
          await playAudio(AudioLeft);
          await sleep(2000);
          window.isReanalyzing = true;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }
        if (eyeStep === "up" && !detectResultFromVideo?.position?.[3]) {
          await playAudio(AudioUp);
          await sleep(2000);
          window.isReanalyzing = true;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }

        // Take image snapshot and take final validation
        const result = await takePictureAndValidate(stepIndex);

        // TODO Handle Crash
        // if (result?.imageValidationCrash) {
        //   alert(JSON.stringify(result.error, null, 4));
        // }
        if (!result?.imageValid) {
          await playAudio(BadQuality);
          await sleep(2000);
          window.isReanalyzing = false;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }

        if (
          (eyeStep === "center" && !result?.validations[0]) ||
          (eyeStep === "right" && !result?.validations[0]) ||
          (eyeStep === "left" && !result?.validations[0]) ||
          (eyeStep === "up" && !result?.validations[0]) ||
          !result?.validations[1] ||
          !result?.validations[2] ||
          !result?.validations[3] ||
          !result?.validations[4] ||
          detectResultFromVideo?.test?.positionFinal
        ) {
          await playAudio(BadQuality);
          await sleep(2000);
          window.isReanalyzing = false;
          if (props.isTest) return;
          return recursiveTakePictureAndValidate();
        }
      };
      await recursiveTakePictureAndValidate();
      window.isReanalyzing = false;
    }
    resizeAndCropImages({
      setThumbnailUrls,
      setthumbnailUrlCoordinates,
      setIsImageValidating,
      MAX_RESOLUTION_WIDTH,
      setEyeImages,
      setSmallImages,
      setSmallImageUrls
    }).then(() => {
      setIsResizeAndCropReady(true);
    }).catch((err) => console.log(err))
    if (props.isTest) {
      window.isTakingPicture = false;
    }
    // Stop Facemesh
    window.stopFaceMesh = true;
    setHideCameraContainer(true);
    setIsQsnOpen(true);
  };

  const uploadFiles = async (qtn) => {
    setIsQsnOpen(false);
    const _thumbnailUrlCoordinates = await asyncGetState(setthumbnailUrlCoordinates);
    const _eyeImages = await asyncGetState(setEyeImages);
    const _smallImages = await asyncGetState(setSmallImages);

    if (_thumbnailUrlCoordinates?.length !== 4 || _eyeImages?.length !== 4 || _smallImages?.length !== 4) {
      return; // TODO: handle if eyeImages, smallImages and Coordinates are missing.
    }

    // Create new form payload
    const formData = new FormData();

    for (let i = 0; i < _eyeImages.length; i++) {
      formData.append("images", _eyeImages[i], "eye" + (i + 1) + ".jpg");
    }

    for (let i = 0; i < _smallImages.length; i++) {
      formData.append("images", _smallImages[i], "capture" + (i + 1) + ".jpg");
    }

    formData.append("coordinates", JSON.stringify(_thumbnailUrlCoordinates));

    formData.append("qtn", JSON.stringify(qtn));
    formData.append("isDemo", location?.state?.isDemo);

    setIsWaitingCovidResult(true);

    const covidResult = await getCovidTestResult(formData);
    if (covidResult) {
      setIsWaitingCovidResult(false);
      handleResult(covidResult, qtn);
    } else {
      setIsWaitingCovidResult(false);
      notifyError("Network Error!");
    }
  };

  const handleResult = async (_covidResult, qtn) => {
    if (_covidResult) {
      const _smallImageUrls = await asyncGetState(setSmallImageUrls);
      history.push({
        pathname: "/result",
        state: {
          response: _covidResult,
          qtn,
          profile: _smallImageUrls,
          isDemo: location?.state?.isDemo
        },
      });
    }
  };

  const takePictureAndValidate = async (_stepIndex) => {
    if (thumbnailUrls.length >= 4) return;

    const imageSrc = webcamRef.current.getScreenshot(cameraResolution);
    const imageDimention = await getImageDimention(imageSrc);

    const image = new Image();
    image.src = imageSrc;

    let drawWidth, drawHeight;
    // Note: Canvas height should not exceed the limit or IOS runs into memory issue.
    // Canvas area should not cross the maximum limit (width * height > 16777216).
    // https://github.com/wojtekmaj/react-pdf/issues/1149 This one is just for relevance.
    if(isMobileOnly) {
      if (imageDimention?.width < MAX_RESOLUTION_WIDTH) {
        drawWidth = imageDimention?.width;
        drawHeight = imageDimention?.height;
      } else {
        const aspectRatio = imageDimention?.height / imageDimention?.width;
        drawWidth = MAX_RESOLUTION_WIDTH;
        drawHeight = MAX_RESOLUTION_WIDTH * aspectRatio;
      }
    } else {
      drawWidth = imageDimention?.width;
      drawHeight = imageDimention?.height;
    }

    const canvasSnapshot = document.createElement("canvas");
    canvasSnapshot.width = drawWidth;
    canvasSnapshot.height = drawHeight;
    const contextSnapshot = canvasSnapshot.getContext("2d");
    contextSnapshot.fillRect(0, 0, drawWidth, drawHeight);
    contextSnapshot.imageSmoothingEnabled = false;
    contextSnapshot.drawImage(image, 0, 0, drawWidth, drawHeight);

    await playAudio(Shutter);
    setIsImageValidating(true);
    let validations = [],
      coordinates;
    try {
      const { validations: _validations, coordinates: _coordinates } = await imageValidation(
        canvasSnapshot,
        _stepIndex,
        drawWidth,
        drawHeight
      );
      console.log("_validations", _validations)
      validations = _validations;
      coordinates = _coordinates;
    } catch (error) {
      // Handle imageValidation Crash on IOS.
      // TODO more crashing test for IOS handling
      return { imageValidationCrash: true, error };
    }
    // const { validations, coordinates } = await imageValidation(canvasSnapshot, thumbnailUrls.length, drawWidth);
    const isAllValidationPass = validations.every((v) => v === true);
    if (validations.length > 0 && isAllValidationPass) {
      setIsImageValidating(false);
      setThumbnailUrls((oldState) => [...oldState, imageSrc]);
      setthumbnailUrlCoordinates((oldCoordinates) => [...oldCoordinates, coordinates]);
      return { validations, coordinates, imageValid: true, imageValidationCrash: false };
    } else {
      setIsImageValidating(false);
      return { validations, coordinates, imageValid: false, imageValidationCrash: false };
    }
  };

  return (
    <>
      <div>
        <div className="testpage" data-testid="testpage-container">
          <p className="upload-link">
            You can upload your photos. please click{" "}
            <a className="manual-upload" data-testid="manual-upload" onClick={goToManual}>
              here
            </a>
            <br />
          </p>
          <div className="canvas-new-container">
            <div className="webcanvas-container">
              {faceLandmarker && hasCameraAccess && (isMobile || isSTablet) ? (
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  data-testid="webcam-testid"
                  width={frameWidth}
                  height={frameHeight}
                  style={{
                    visibility: isCameraResolutionValid || hideCameraContainer ? "hidden" : "",
                    transform: cameraMode == "environment" ? "scaleX(1)" : "",
                  }}
                  videoConstraints={{
                    facingMode: cameraMode,
                    frameRate: isMobile || isSTablet ? 15 : 30,
                  }}
                  onLoadedData={handleVideoLoad}
                  screenshotFormat="image/jpeg"
                  screenshotQuality={1}
                  className={landscapeMode ? "covid-video-desktop" : "covid-video"}
                />
              ) : cameraMaxResolution ? (
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  data-testid="webcam-testid"
                  width={frameWidth}
                  height={frameWidth * cameraAspectRatio}
                  style={{
                    visibility: isCameraResolutionValid || hideCameraContainer ? "hidden" : "",
                    transform: cameraMode == "environment" ? "scaleX(1)" : "",
                  }}
                  videoConstraints={{
                    facingMode: cameraMode,
                    frameRate: 15,
                    width: frameWidth,
                    height: frameWidth * cameraAspectRatio
                  }}
                  onLoadedData={handleVideoLoad}
                  onUserMediaError={(error) => console.log(error)}
                  screenshotFormat="image/jpeg"
                  screenshotQuality={1}
                  className="covid-video-desktop"
                />
              ) : (
                <div className="video-placerholder-desktop" style={{ width: 640, height: 480 }}></div>
              )}
              {hideCameraContainer && <div className="image-complete-placeholder"></div>}

              {!(isMobile || isSTablet) && cameraMaxResolution ? (
                <canvas
                  style={{ visibility: isCameraResolutionValid || hideCameraContainer ? "hidden" : "" }}
                  ref={canvasRef}
                  className="covid-canvas-desktop"
                  width={cameraMaxResolution?.width}
                  height={cameraMaxResolution?.height * cameraAspectRatio}
                ></canvas>
              ) : (
                <canvas
                  style={{ visibility: isCameraResolutionValid || hideCameraContainer ? "hidden" : "" }}
                  ref={canvasRef}
                  className={landscapeMode ? "covid-canvas-desktop" : "covid-canvas"}
                  width={frameWidth}
                  height={frameHeight}
                ></canvas>
              )}
              <img
                src={CloseIcon}
                className="close-button"
                data-testid="close-button"
                alt="Close"
                onClick={() => {
                  handleClose();
                }}
              />
              {counter && <div className="test-counter">{counter}</div>}
            </div>
            {isCamLoading || !faceLandmarker ? (
              <div className="loading-spinner-v2">
                <p className="loading-text">
                  {isSlow && <span>Your network is unreachable or very slow.</span>}
                  <br />
                  {!faceLandmarker ? LOADING_ENVIRONMENT : LOADING_MSG}
                </p>
              </div>
            ) : (
              <></>
            )}
            {isImageValidating && (
              <div className="loading-spinner-v2">
                <p className="loading-text">Validating Image...</p>
              </div>
            )}
            {isFailed ? (
              <div className="failed-icon-v2" data-testid="camera-fail">
                <div className="loading-text">
                  <p>iSelfie Test requires access to your camera to perform the test.</p>
                  <p>{errorMsg}</p>
                  <Button data-testid="retry" variant="primary" id="retry" style={{ padding: 0 }} onClick={handleRetry}>
                    Retry
                  </Button>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="snapshots-div">
            <div className="snapshots">
              {thumbnailUrls[0] ? (
                <img className="center thumbnail" src={thumbnailUrls[0]} alt="center" />
              ) : (
                <img className="center" src={landscapeMode ? LandscapeCenter : CenterMan} id="pic1" alt="center" />
              )}
              <span>Eyes Center</span>
            </div>
            <div className="snapshots">
              {thumbnailUrls[1] ? (
                <img className="right thumbnail" src={thumbnailUrls[1]} alt="left" />
              ) : (
                <img className="right" src={landscapeMode ? LandscapeLeft : LeftMan} id="pic2" alt="left" />
              )}
              <span>Eyes Right</span>
            </div>
            <div className="snapshots">
              {thumbnailUrls[2] ? (
                <img className="left thumbnail" src={thumbnailUrls[2]} alt="right" />
              ) : (
                <img className="left" src={landscapeMode ? LandscapeRight : RightMan} id="pic3" alt="right" />
              )}

              <span>Eyes Left</span>
            </div>
            <div className="snapshots">
              {thumbnailUrls[3] ? (
                <img className="up thumbnail" src={thumbnailUrls[3]} alt="up" />
              ) : (
                <img className="up" src={landscapeMode ? LandscapeUp : UpMan} id="pic4" alt="up" />
              )}

              <span>Eyes Up</span>
            </div>
          </div>
        </div>
      </div>
      <QuestionnaireV2
        isOpen={isQsnOpen}
        onSubmit={uploadFiles}
        isResizeAndCropReady={isResizeAndCropReady}
        version={2}
      />
      <Modal
        animation={false}
        show={isCameraResolutionValid}
        onHide={handleClose}
        centered
        backdrop="static"
        className="warning_modal"
      >
        <Modal.Header>
          <Modal.Title>
            Camera Quality
            {cameraResolution ? `(${cameraResolution?.width} X ${cameraResolution?.height})` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="body">
          <p>Your camera does not meet the minimum requirements of the iSelfie test.</p>
          <p>You can manually upload your photos.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" id="cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" id="continue" onClick={goToManual}>
            Manual upload
          </Button>
        </Modal.Footer>
      </Modal>
      {isWaitingCovidResult && <Waiting isWaiting={isWaitingCovidResult} list={covidMessageList} />}
      <Modal animation={false} show={faceMesh} onHide={handleRetry} centered className="faceMesh_modal">
        <Modal.Header>
          <Modal.Title>Connection Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="body">
          <p>Your network is unreachable or very slow.</p>
          <p>Please check your networks and then refresh this page.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" id="roload" onClick={handleRetry}>
            Reload
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
